<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Import Tasks</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-3">

  <form id="file-upload-form" class="uploader d-flex flex-column align-items-center" appDragAndDrop *ngIf="actionsDataAfter.length === 0" (fileDropped)="onFileChange($event)">

      <input #fileInput id="file-upload" type="file" name="fileUpload" accept=".xls,.xlsx,.csv" (change)="onFileChange($event.target?.files[0])"/>
      <div id="file-drag" class="upload-container">
        <div id="start">
          <div>{{(selectedFile && fileIsExcel(selectedFile.name)) ? selectedFile.name : 'Select a file or drag & drop it here. You can upload a CSV, XLS or XLSX file.'}}</div><br>
          <div><strong>Please make sure your file has less than 100 rows of data.</strong></div>
          <button id="file-upload-btn" mat-raised-button color="primary" class="mt-3" (click)="fileInput.click()">
            Select a file
          </button>
        </div>
      </div>

      <div class="my-2">
        <mat-form-field class="m-2" appearance="outline" subscriptSizing="dynamic" *ngIf="sheetNames">
          <mat-label>Excel Sheets</mat-label>
          <mat-select>
            <mat-option *ngFor="let sheet of sheetNames" (click)="excelSheetSelected(sheet)" [value]="sheet">
              {{ sheet }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" class="m-2" *ngIf="sheetNames" [disabled]="actionsDataBefore.length === 0" (click)="onConfirm()">
          Confirm
        </button>
      </div>

  </form>

  <div class="py-2"  *ngIf="actionsDataAfter.length !== 0">

    <div class="alert alert-warning mb-4" role="alert">
        Only the first 100 tasks will be imported. Please split your task lists into files of 100 tasks each if you have more than 100 tasks to import.
    </div>

    <div class="row">
      <div class="col-12 col-xl-2">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Due Date</mat-label>
          <input
            matInput
            (dateInput)="onAllDateChange($event.value)"
            [matDatepicker]="picker"
            placeholder="Due Date"
            name="due"
            #due
            readonly
            (click)="picker.open()"
          />
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Type</mat-label>
          <mat-select matInput (selectionChange)="onAllTypeChange($event.value)" name="type" placeholder="Type">
            <mat-option *ngFor="let type of types" [value]="type">
              {{type}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Priority</mat-label>
          <mat-select matInput (selectionChange)="onAllPriorityChange($event.value)" name="priority" placeholder="Priority">
            <mat-option *ngFor="let priority of priorities" [value]="priority">
              {{priority}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-4">
        <button
          mat-raised-button
          type="button"
          (click)="onAllSelectSite()"
          class="my-2 ml-0 mr-3"
          color="secondary">
          <mat-icon>location_on</mat-icon>
          {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
        </button>

        <button
          mat-raised-button
          type="button"
          (click)="onAllAddUsers()"
          class="my-2 ml-0 mr-3"
          color="secondary">
          <mat-icon>account_circle</mat-icon>
          Add Users
        </button>
      </div>
    </div>

    <span *ngIf="selection.selected.length !== 0">{{selection.selected.length + ' tasks selected'}}</span>
  </div>

  <div *ngIf="actionsDataAfter.length !== 0">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="task_name">
        <th mat-header-cell *matHeaderCellDef> Task Name </th>
        <td mat-cell *matCellDef="let action">
          <mat-form-field class="full-width my-3" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Task</mat-label>
            <input
              matInput
              placeholder="Task"
              [(ngModel)]="action.name"
              name="name"
              type="text"
              required
              #name />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="task_description">
        <th mat-header-cell *matHeaderCellDef> Task Description </th>
        <td mat-cell *matCellDef="let action">
          <mat-form-field class="full-width my-3" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Description</mat-label>
            <input
              matInput
              placeholder="Description"
              [(ngModel)]="action.description"
              name="description"
              type="text"
              #description />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef> Type </th>
        <td mat-cell *matCellDef="let action">
          <mat-form-field class="full-width my-3" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Type</mat-label>
            <mat-select matInput [(ngModel)]="action.type" name="type" required>
              <mat-option *ngFor="let type of types" [value]="type">
                {{type}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="due_date">
        <th mat-header-cell *matHeaderCellDef> Due Date </th>
        <td mat-cell *matCellDef="let action">
          <mat-form-field class="full-width my-3" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Due Date</mat-label>
            <input
              matInput
              (dateInput)="onDateChange($event.value, action)"
              [matDatepicker]="picker"
              placeholder="Due Date"
              [(ngModel)]="action.due"
              name="due"
              #due
              readonly
              (click)="picker.open()" />
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef> Priority </th>
        <td mat-cell *matCellDef="let action">
          <mat-form-field class="full-width my-3" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Priority</mat-label>
            <mat-select matInput [(ngModel)]="action.priority" name="priority">
              <mat-option *ngFor="let priority of priorities" [value]="priority">
                {{priority}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="origin">
        <th mat-header-cell *matHeaderCellDef> Origin </th>
        <td mat-cell *matCellDef="let action">
          <mat-select style="min-width: 100px;" matInput [(ngModel)]="action.origin" name="origin">
            <mat-option *ngFor="let origin of nonSystemOrigins" [value]="origin">
              {{origin}}
            </mat-option>
          </mat-select>
        </td>
      </ng-container>

      <ng-container matColumnDef="individual">
        <th mat-header-cell *matHeaderCellDef> Individual </th>
        <td mat-cell *matCellDef="let action">
          <mat-slide-toggle [(ngModel)]="action.individual_actions" name="individual-actions"></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="buttons">
        <th mat-header-cell *matHeaderCellDef></th>

        <td mat-cell *matCellDef="let action">
          <div class="py-2">
            <button
              mat-raised-button
              type="button"
              (click)="onSelectSite(action)"
              [matBadge]="'' + (action.site_id ? 1 : 0)"
              class="my-2 ml-1 mr-2"
              color="secondary">
              <mat-icon>location_on</mat-icon>
              Site
            </button>

            <button
              mat-raised-button
              type="button"
              (click)="onAddUsers(action)"
              [matBadge]="action.user_ids?.length"
              class="my-2 ml-1 mr-2"
              color="secondary">
              <mat-icon>account_circle</mat-icon>
              Add Users
            </button>
          <!-- <button type="button" mat-button (click)="onAddFiles(action)" matTooltip="Add files to the task." matTooltipPosition="above">
            Add Files
          </button> -->
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

</mat-dialog-content>

<hr class="m-0 p-0" *ngIf="actionsDataAfter.length !== 0">

<mat-dialog-actions class="d-flex justify-content-end px-2 py-1" *ngIf="actionsDataAfter.length !== 0">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [pageSizeOptions]="[10, 20, 40]"
    showFirstLastButtons>
  </mat-paginator>

  <button
    [disabled]="inProgress"
    type="button"
    mat-raised-button
    class="my-2 ml-1 mr-2"
    color="primary"
    (click)="onSaveAndClose()">
    <mat-icon>save</mat-icon> Save
  </button>
</mat-dialog-actions>
